import api from './client'
import type { PaginatedResponse } from './leads'

export interface Contact {
  id: string
  companyId: string
  firstName: string
  lastName: string
  email: string | null
  phone: string | null
  organizationId: string | null
  jobTitle: string | null
  customFields: Record<string, unknown>
  createdAt: string
  updatedAt: string
}

export interface Organization {
  id: string
  companyId: string
  name: string
  description: string | null
  isActive: boolean
  color: string | null
  createdAt: string
  updatedAt: string
}

export const contactsApi = {
  list: (companyId: string, params: Record<string, unknown> = {}) =>
    api.get<PaginatedResponse<Contact>>(`/companies/${companyId}/contacts`, { params }),
  get: (companyId: string, id: string) =>
    api.get<Contact>(`/companies/${companyId}/contacts/${id}`),
  create: (companyId: string, dto: Partial<Contact>) =>
    api.post<Contact>(`/companies/${companyId}/contacts`, dto),
  update: (companyId: string, id: string, dto: Partial<Contact>) =>
    api.patch<Contact>(`/companies/${companyId}/contacts/${id}`, dto),
  remove: (companyId: string, id: string) =>
    api.delete(`/companies/${companyId}/contacts/${id}`),
}

export const organizationsApi = {
  list: (companyId: string, params: Record<string, unknown> = {}) =>
    api.get<PaginatedResponse<Organization>>(`/companies/${companyId}/organizations`, { params }),
  get: (companyId: string, id: string) =>
    api.get<Organization>(`/companies/${companyId}/organizations/${id}`),
  create: (companyId: string, dto: Partial<Organization>) =>
    api.post<Organization>(`/companies/${companyId}/organizations`, dto),
  update: (companyId: string, id: string, dto: Partial<Organization>) =>
    api.patch<Organization>(`/companies/${companyId}/organizations/${id}`, dto),
  remove: (companyId: string, id: string) =>
    api.delete(`/companies/${companyId}/organizations/${id}`),
}
